import { sumBy } from '@workalizer/shared/utils';
import { calculateAverage, getInterval, getPercentageDiff, groupByPeriod } from '@workalizer/shared/utils';
var mockCurrentPeriodData = [
    {
        docsCommentsPosted: 2,
        meetingsOrganized: 1,
        chatMessagesSent: 8,
        emailsSent: 3
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 2,
        emailsSent: 1
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 0,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 11,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 1,
        meetingsOrganized: 0,
        chatMessagesSent: 2,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 0,
        emailsSent: 0
    }
];
var mockPreviousPeriodData = [
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 3,
        chatMessagesSent: 0,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 2,
        chatMessagesSent: 2,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 1,
        chatMessagesSent: 10,
        emailsSent: 1
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 17,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 0,
        emailsSent: 0
    }
];
var mockTeamAverageData = [
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 29,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 28,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 59,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 101,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 23,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 0,
        emailsSent: 0
    }
];
export var activityCountsByIndependentWork = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var periods = groupByPeriod([], new Date(input.dateFrom), new Date(input.dateTo), interval);
    var currentPeriod = periods.map(function (period, idx) {
        var mockData = mockCurrentPeriodData[idx % mockCurrentPeriodData.length];
        if (input.userId === null) {
            return {
                period: period.date,
                docsCommentsPosted: mockData.docsCommentsPosted * 3,
                meetingsOrganized: mockData.meetingsOrganized * 2,
                chatMessagesSent: mockData.chatMessagesSent * 4,
                emailsSent: mockData.emailsSent * 2
            };
        }
        return {
            period: period.date,
            docsCommentsPosted: mockData.docsCommentsPosted,
            meetingsOrganized: mockData.meetingsOrganized,
            chatMessagesSent: mockData.chatMessagesSent,
            emailsSent: mockData.emailsSent
        };
    });
    var previousPeriod = periods.map(function (period, idx) {
        var mockData = mockPreviousPeriodData[idx % mockPreviousPeriodData.length];
        if (input.userId === null) {
            return {
                period: period.date,
                docsCommentsPosted: mockData.docsCommentsPosted * 3,
                meetingsOrganized: mockData.meetingsOrganized * 2,
                chatMessagesSent: mockData.chatMessagesSent * 4,
                emailsSent: mockData.emailsSent * 2
            };
        }
        return {
            period: period.date,
            docsCommentsPosted: mockData.docsCommentsPosted,
            meetingsOrganized: mockData.meetingsOrganized,
            chatMessagesSent: mockData.chatMessagesSent,
            emailsSent: mockData.emailsSent
        };
    });
    var teamAverage = periods.map(function (period, idx) {
        var mockData = mockTeamAverageData[idx % mockTeamAverageData.length];
        return {
            period: period.date,
            docsCommentsPosted: mockData.docsCommentsPosted,
            meetingsOrganized: mockData.meetingsOrganized,
            chatMessagesSent: mockData.chatMessagesSent,
            emailsSent: mockData.emailsSent
        };
    });
    var totalDocsComments = sumBy(currentPeriod, 'docsCommentsPosted');
    var totalMeetings = sumBy(currentPeriod, 'meetingsOrganized');
    var totalChatMessages = sumBy(currentPeriod, 'chatMessagesSent');
    var totalEmails = sumBy(currentPeriod, 'emailsSent');
    var prevTotalDocsComments = sumBy(previousPeriod, 'docsCommentsPosted');
    var prevTotalMeetings = sumBy(previousPeriod, 'meetingsOrganized');
    var prevTotalChatMessages = sumBy(previousPeriod, 'chatMessagesSent');
    var prevTotalEmails = sumBy(previousPeriod, 'emailsSent');
    var docsCommentsDiff = getPercentageDiff(prevTotalDocsComments, totalDocsComments);
    var meetingsDiff = getPercentageDiff(prevTotalMeetings, totalMeetings);
    var chatMessagesDiff = getPercentageDiff(prevTotalChatMessages, totalChatMessages);
    var emailsDiff = getPercentageDiff(prevTotalEmails, totalEmails);
    var teamTotalDocsComments = sumBy(teamAverage, 'docsCommentsPosted');
    var teamTotalMeetings = sumBy(teamAverage, 'meetingsOrganized');
    var teamTotalChatMessages = sumBy(teamAverage, 'chatMessagesSent');
    var teamTotalEmails = sumBy(teamAverage, 'emailsSent');
    var teamAvgDocsComments = calculateAverage(teamTotalDocsComments, 4);
    var teamAvgMeetings = calculateAverage(teamTotalMeetings, 4);
    var teamAvgChatMessages = calculateAverage(teamTotalChatMessages, 4);
    var teamAvgEmails = calculateAverage(teamTotalEmails, 4);
    var teamDocsCommentsDiff = getPercentageDiff(teamAvgDocsComments, totalDocsComments);
    var teamMeetingsDiff = getPercentageDiff(teamAvgMeetings, totalMeetings);
    var teamChatMessagesDiff = getPercentageDiff(teamAvgChatMessages, totalChatMessages);
    var teamEmailsDiff = getPercentageDiff(teamAvgEmails, totalEmails);
    var result = {
        totals: {
            docsCommentsPosted: totalDocsComments,
            meetingsOrganized: totalMeetings,
            chatMessagesSent: totalChatMessages,
            emailsSent: totalEmails,
            prevPeriodDiffs: {
                docsCommentsPosted: docsCommentsDiff,
                meetingsOrganized: meetingsDiff,
                chatMessagesSent: chatMessagesDiff,
                emailsSent: emailsDiff
            }
        },
        currentPeriod: currentPeriod,
        previousPeriod: previousPeriod
    };
    if (input.userId !== null) {
        result.totals.teamAverageDiffs = {
            docsCommentsPosted: teamDocsCommentsDiff,
            meetingsOrganized: teamMeetingsDiff,
            chatMessagesSent: teamChatMessagesDiff,
            emailsSent: teamEmailsDiff
        };
        result.teamAverage = teamAverage;
    }
    return result;
};
